import axios from '@utils/axios';
import router from '@router/router';
import i18n from '@utils/localization';

const userDetail = {
  state: {
    userId: 0,
    email: '',
    color: 1,
    phoneNumber: '',
    role: {},
    oldPassword: '',
    newPassword: ''
  },
  mutations: {
    setUserId(state, id) {
      state.userId = id;
    },
    setEmail(state, email) {
      state.email = email;
    },
    setPhoneNumber(state, number) {
      state.phoneNumber = number;
    },
    setColor(state, color) {
      state.color = color;
    },
    setRole(state, role) {
      state.role = role;
    },
    setOldPassword(state, pass) {
      state.oldPassword = pass;
    },
    setNewPassword(state, newPass) {
      state.newPassword = newPass;
    }
  },
  actions: {
    fetchUser(context, id) {
      return axios.get('admin/users/getuser', {
        params: {
          Id: id,
          Locale: i18n.locale
        }
      })
        .then((res) => {
          if (res.status === 404) {
            router.push({ name: 'admin.users.view' });
          } else if (res.status === 200) {
            context.commit('setUserId', id);
            context.commit('setEmail', res.data.result.email);
            context.commit('setRole', res.data.result.role);
            context.commit('setColor', res.data.result.color);
            Promise.resolve(true);
          }
        }).catch(() => {
          router.push({ name: 'admin.dashboard' });
        });
    },
    changePassword(context) {
      return axios.post('auth/changepassword', {
        OldPassword: context.state.oldPassword,
        newPassword: context.state.newPassword
      });
    },
    changeDetails(context) {
      return axios.post('admin/userpanel/changeDetails', {
        Email: context.state.email,
        PhoneNumber: context.state.phoneNumber,
        Color: context.state.color
      });
    },
    resetContext(context) {
      context.commit('setUserId', 0);
      context.commit('setEmail', '');
      context.commit('setColor', 1);
      context.commit('setPhoneNumber', '');
      context.commit('setRole', {});
      context.commit('setOldPassword', '');
      context.commit('setNewPassword', '');
    }
  },
  namespaced: true
};

export default userDetail;
